export enum AlertVariation {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Success = 'success',
  Warning = 'warning',
  Info = 'info'
}
